import { connect } from 'react-redux';
import MusicCard from '../components/MusicCard';
import { pauseMediaPlayer, playLive } from '../../aovivoBar/actions/MediaPlayerActions';
import { getLocalStoreRating, rateRating } from '../../aovivoBar/actions/RatingActions';
import shorthash from '../../../helpers/shorthash';

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const isLive = aovivoBar.MediaPlayer.isLive !== 'otherMedia';
    const musicLive = isLive
        ? aovivoBar.NowPlaying.musicLive
        : aovivoBar.NowPlaying.music;
    const { artist, song, time } = musicLive;
    const { rating, musicHash } = aovivoBar.Rating;
    const newHash = shorthash(`${song}-${artist}-${time}`)

    // artist song isLIve metaType currentMetaId rating settingRating
    return {
        cover: musicLive.cover,
        artist,
        song,
        metaType: musicLive.metaType,
        currentMetaId: aovivoBar.MediaPlayer.currentStream.metaId,
        settingRating: aovivoBar.Rating.settingRating,
        rating: newHash === musicHash ? rating : null,
        playerStatus: aovivoBar.MediaPlayer.playerStatus,
        isLive,
    };
};

const mapDispatchToProps = (dispatch) => ({
    playLive: () => {
        dispatch(playLive());
    },
    pauseMediaPlayer: () => {
        dispatch(pauseMediaPlayer());
    },
    getLocalStoreRating: () => {
        dispatch(getLocalStoreRating());
    },
    onLiked: () => {
        dispatch(rateRating(10));
    },
    onDisliked: () => {
        dispatch(rateRating(1));
    },
});

const MusicCardContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MusicCard);

export default MusicCardContainer;
